import { useCallback } from 'react'

import {
  focusEditor,
  getEndPoint,
  insertText,
  isEditorFocused,
  select,
} from '@udecode/plate'

import type { BufferEditor } from '../../BufferEditor/types.plate'

type UseEmojiInsertProps = {
  editor: BufferEditor
}

/**
 * Hook for inserting emojis at cursor position in Plate editors.
 *
 * @param editor - Plate editor instance
 * @returns Function that inserts emoji at cursor position
 *
 * @example
 * ```tsx
 * const handleEmojiSelect = useEmojiInsert({ editor })
 * <EmojiPicker onEmojiSelect={handleEmojiSelect} />
 * ```
 */
export const useEmojiInsert = ({
  editor,
}: UseEmojiInsertProps): ((emoji: string) => void) => {
  return useCallback(
    (emoji: string) => {
      if (!isEditorFocused(editor)) focusEditor(editor)
      if (!editor.selection) {
        const editorEnd = getEndPoint(editor, [])
        select(editor, { anchor: editorEnd, focus: editorEnd })
      }
      insertText(editor, `${emoji} `)
    },
    [editor],
  )
}
